import { Component, Input } from "@angular/core";
import { NewProviderInformation } from "@core/model";
import { OrderingProviderPac } from "@shared/model";

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'ordering-provider',
    templateUrl: './ordering-provider.component.html',
    styleUrls: ['./ordering-provider.component.scss'],
    standalone: false
})
export class OrderingProviderComponent {
  orderingProviderData!: OrderingProviderPac;
  orderingData: NewProviderInformation;
  panelName: string;
  @Input() isGoldCardVisible = false;
  @Input() isPASComplete: boolean;

  private _isGoldCardProvider = false;
  private _goldCardAuthorizationType = "";

  get isGoldCardProvider(): boolean {
    return this._isGoldCardProvider;
  }

  get goldCardAuthorizationType(): string {
    return this._goldCardAuthorizationType;
  }

  @Input() set orderingProvider(value: OrderingProviderPac) {
    this.orderingProviderData = value;
 this._isGoldCardProvider = value.provider?.isGoldCardProvider || false;
 this._goldCardAuthorizationType = value.provider?.goldCardAuthorizationType || null;

    if (value.provider) {
      this.panelName = 'Ordering Provider Details';

      this.orderingData = {
        practiceNpinumber: value.provider.physicianAccountViewDTO.practiceNpinumber,
        firstName: '',
        lastName: '',
        practiceTaxId: value.provider.physicianAccountViewDTO.practiceTaxId,
        physicalStreet: value.provider.physicianAccountViewDTO.physicalStreet,
        physicalCity: value.provider.physicianAccountViewDTO.physicalCity,
        physicalState: value.provider.physicianAccountViewDTO.physicalState,
        physicalZip: value.provider.physicianAccountViewDTO.physicalZip,
        phone: value.provider.physicianAccountViewDTO.phone,
        fax: value.provider.physicianAccountViewDTO.fax
      };
    } else {
      this.orderingData = value.physicianContact;
      this.panelName = 'Enter new Ordering Provider information';
    }
  }
}
